<template>
  <!-- <div class="category-wrapper"> -->
    <span class="category">
      <fa v-for="n in stars"
          :key="n"
          fa-class="star"
          :padding="false"
      />
    </span>
  <!-- </div> -->
</template>

<script>
import fa from '@/components/global/icon/fontAwesome'

export default {
  components: {
    fa
  },
  props: {
    stars: Number
  }
}
</script>
